// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__16d7e","noInteraction":"EventWrapper_noInteraction__mX9T4"};